export default __webpack_public_path__ + "static/media/Group 30884.cbc8fba3.svg";